import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import './Terms.css';

export function Section({ data }) {
  const intro = data.intro;
  const intro2 = data.intro2;
  const bullets = data.bullets;
  const outro = data.outro;
  const body = data.body;

  return (
    <section className="terms__section">
      <h2 className="terms__section-title">
        <span className="terms__section-num">{data.num}</span>
        <span>{data.title}</span>
      </h2>
      {body && <p>{body}</p>}
      {intro && <p>{intro}</p>}
      {intro2 && <p>{intro2}</p>}
      {Array.isArray(bullets) && bullets.length > 0 && (
        <ul className="terms__list">
          {bullets.map((b, i) => (
            <li key={i}>
              {typeof b === 'string'
                ? b
                : <><strong>{b.bold}</strong> {b.text}</>}
            </li>
          ))}
        </ul>
      )}
      {outro && <p>{outro}</p>}
    </section>
  );
}

export default function Terms() {
  const { t } = useTranslation();
  const sectionKeys = ['s1', 's2', 's3', 's4', 's5', 's6', 's7', 's8'];

  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="terms">
      <Helmet>
        <title>{t('terms.meta_title')}</title>
        <meta name="description" content={t('terms.meta_desc')} />
        <link rel="canonical" href="https://troly.club/terminos" />
      </Helmet>

      <div className="container fade-up">
        <Link to="/" className="terms__back" aria-label={t('terms.back_to_home')}>
          <svg width="14" height="14" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 4l-6 6 6 6" />
          </svg>
          {t('terms.back_to_home')}
        </Link>

        <h1 className="terms__title">{t('terms.title')}</h1>
        <p className="terms__updated">{t('terms.updated')}</p>

        <div className="terms__intro">
          <p>{t('terms.intro_p1')}</p>
          <p>{t('terms.intro_p2')}</p>
        </div>

        <hr className="terms__divider" />

        {sectionKeys.map((key) => {
          const data = t(`terms.${key}`, { returnObjects: true });
          if (!data || typeof data !== 'object') return null;
          return <Section key={key} data={data} />;
        })}

        <p className="terms__footer-note">{t('terms.footer_note')}</p>
      </div>
    </div>
  );
}
